export const GET_ACCESS_FORMS = 'GET_ACCESS_FORMS';
export const GET_ACCESS_FORMS_ERROR = 'GET_ACCESS_FORMS_ERROR';
export const GET_ACCESS_FORMS_SUCCESS = 'GET_ACCESS_FORMS_SUCCESS';
export const LOAD_MORE = 'LOAD_MORE_ACCESS_FORMS';
export const GET_FORMS_BY_ID_ERROR = 'GET_FORMS_BY_ID_ERROR';
export const GET_FORMS_BY_ID_LOADER = 'GET_FORMS_BY_ID_LOADER';
export const GET_FORMS_BY_ID_SUCCESS = 'GET_FORMS_BY_ID_SUCCESS';
export const GET_FORMS_BY_ID = 'GET_FORMS_BY_ID';
